import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { AccountingSeatsHeaderTiles, AccountingSeatsTable } from '../../containers'
// import {accountingSeatOperations} from "../../../../state/ducks/accounting-seat-settings";
import { connect } from 'react-redux'
import * as PropTypes from 'prop-types'
import { PaginationShape } from '../../../../prop-types'
import { jsonToQueryString } from '../../../../state/utils/apiService'
import { history } from '../../../../routing/History'

class AccountingSeatsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchAccountingSeats = this.fetchAccountingSeats.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.addQueryParam = this.addQueryParam.bind(this)
    this.updateQueryParams = this.updateQueryParams.bind(this)
    this.onSortBy = this.onSortBy.bind(this)
  }

  UNSAFE_componentWillMount () {
    // this.fetchAccountingSeats(queryStringToJSON(this.props.location.search));
  }

  componentDidMount () {
    window.scrollTo(0, 0)
  }

  UNSAFE_componentWillReceiveProp (nextProps, nextContext) {
    if (nextProps.location.search !== this.props.location.search) {
      // this.fetchAccountingSeats(queryStringToJSON(nextProps.location.search));
    }
  }

  fetchAccountingSeats (params) {
    this.setState({ params }, () => this.props.fetchAccountingSeats(this.state.params))
  }

  onPaginationChange (page) {
    this.addQueryParam('page', page)
  }

  onSearchChange (keywork) {
    this.addQueryParam('search', keywork)
  }

  onSortBy (att, sortBy) {
    this.addQueryParam('ordering', sortBy === -1 ? '-' + att : att)
  }

  addQueryParam (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.updateQueryParams(params)
  }

  updateQueryParams (params = null) {
    history.push({
      pathname: this.props.location.pathname,
      search: params ? jsonToQueryString(params) : ''
    })
  }

  render () {
    const renderHeaderPaths = () => {
      return (
                <>
                    <li>Accounting Seats</li>
                </>
      )
    }

    return (
            <>
                <PageContainerLayout
                    clientSidebar={true}
                    showNavbarClientOptions={true}
                >
                    {/* Page Header */}
                    <PageHeaderLayout
                        title={'Accounting Seats'}
                        subTitle={'Dashboard'}
                        paths={renderHeaderPaths}
                    />
                    {/* END Page Header */}
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <AccountingSeatsHeaderTiles
                            statusGroups={this.props.statusGroups}
                            onQueryParamsChange={this.updateQueryParams}
                        />
                        {/* END Header Tiles */}
                        <div className={
                            ' block block-themed block-opt-refresh-icon7 ' +
                            (this.props.isLoading ? ' block-opt-refresh ' : '')
                        }>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button" data-toggle="block-option"
                                                data-action="fullscreen_toggle">
                                            <i className="si si-size-fullscreen"/>
                                        </button>
                                    </li>
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchAccountingSeats}
                                        >
                                            <i className="si si-refresh"/>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All Accounting Seats</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout
                                    onSearchChange={this.onSearchChange}
                                />
                                {/* End Search */}
                                {/* Table */}
                                <AccountingSeatsTable
                                    accountingSeats={this.props.accountingSeats}
                                    onSortBy={this.onSortBy}
                                >
                                    {/* Pagination */}
                                    <PaginationLayout
                                        pagination={this.props.paginationData}
                                        onPaginationChange={this.onPaginationChange}
                                    />
                                    {/* End Pagination */}
                                </AccountingSeatsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
AccountingSeatsPage.propTypes = {
  accountingSeats: PropTypes.array,
  fetchAccountingSeats: PropTypes.func.isRequired,
  paginationData: PaginationShape,
  statusGroups: PropTypes.array
}

// Set defaultProps
AccountingSeatsPage.defaultProps = {
  accountingSeats: [],
  paginationData: {},
  statusGroups: []
}

// mapStateToProps
const mapStateToProps = (state) => ({
  // isLoading: state.accountingSeats.fetchAccountingSeatsReducer.loading,
  // accountingSeats: state.accountingSeats.fetchAccountingSeatsReducer.data.results,
  // paginationData: state.accountingSeats.fetchAccountingSeatsReducer.data.pagination_data,
  // statusGroups: state.accountingSeats.fetchAccountingSeatsReducer.data.status_groups
})

// mapStateToProps
const mapDispatchToProps = {
  // fetchAccountingSeats: accountinwgSeatOperations.list
}

// Export Class
const _AccountingSeatsPage = connect(mapStateToProps, mapDispatchToProps)(AccountingSeatsPage)
export { _AccountingSeatsPage as AccountingSeatsPage }
